import {
  type HTMLChakraProps,
  useStyleConfig,
  Spinner,
} from '@chakra-ui/react';
import { forwardRef } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

import { SendIcon } from '@frontend/components';

import { usePromptBarContext } from '../PromptBarContext';
import { usePromptBarStyles } from '../usePromptBarStyles';

export type PromptBarSubmitButtonProps = Omit<
  HTMLChakraProps<'button'>,
  'children'
>;

/**
 * Footer for PromptBar.
 */
export const PromptBarSubmitButton: React.FC<PromptBarSubmitButtonProps> =
  forwardRef<PromptBarSubmitButtonProps, 'button'>(
    ({ children, ...props }, ref) => {
      const { submitButton } = usePromptBarStyles();
      const iconButton = useStyleConfig('IconButton', { size: 'lg' });
      const {
        isDisabled,
        onSubmit,
        isSubmitting,
        isGenerating,
        isSubmissionDisabled,
      } = usePromptBarContext();

      return (
        <chakra.button
          sx={{ ...iconButton, ...submitButton }}
          disabled={
            isDisabled || isSubmissionDisabled || isSubmitting || isGenerating
          }
          onClick={onSubmit}
          {...props}
          ref={ref}
        >
          {isSubmitting || isGenerating ? <Spinner size="md" /> : <SendIcon />}
        </chakra.button>
      );
    },
  );
PromptBarSubmitButton.displayName = 'PromptBarSubmitButton';
